<section class="add">
	<button
		class="add__dismiss"
		aria-label="Close Add Vet Modal"
		data-quat="action_modalDismiss"
		(click)="close()"
	>
		<svg
			aria-hidden="true"
			width="56"
			height="56"
			viewBox="0 0 56 56"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="23.759"
				height="2.64"
				rx="1"
				transform="rotate(-45 52.145 -4.8)"
				fill="#333"
			/>
			<rect
				width="23.759"
				height="2.64"
				rx="1"
				transform="rotate(45 -12.266 34.12)"
				fill="#333"
			/>
		</svg>
	</button>
	<section class="add__stepper">
		<mv-stepper>
			<mv-step
				#mvStep
				[step]="1"
				ariaLabel="Search Vets"
			></mv-step>
			<mv-step
				#mvStep
				[step]="2"
				ariaLabel="Add other names"
			></mv-step>
			<mv-step
				#mvStep
				[step]="3"
				ariaLabel="Add other owners"
			></mv-step>
		</mv-stepper>
	</section>
	<main class="add__main">
		<!-- TODO: This is where the switch case will go -->
		<ng-container *ngIf="petId">
			<ng-container [ngSwitch]="workflowStep$ | async">
				<mv-vet-clinic
					*ngSwitchCase="WorkflowStep.VetClinic"
					(_emb_close)="close($event)"
					#vetClinicStep
				></mv-vet-clinic>
				<mv-new-vet
					*ngSwitchCase="WorkflowStep.AddNewVet"
					(_emb_close)="close($event)"
				></mv-new-vet>
				<mv-other-owners
					*ngSwitchCase="WorkflowStep.OtherOwners"
					(_emb_close)="close($event)"
				></mv-other-owners>
				<mv-other-names
					*ngSwitchCase="WorkflowStep.OtherNames"
					(_emb_close)="close($event)"
				></mv-other-names>
				<mv-celebration
					*ngSwitchCase="WorkflowStep.Celebration"
					(_emb_close)="close($event)"
				></mv-celebration>
			</ng-container>
		</ng-container>
	</main>
</section>